import React from 'react';
import { useSiteSettings } from '../../siteSettings';

const PublicDevtoolsGuard = () => {
  const settings = useSiteSettings();

  React.useEffect(() => {
    if (!settings.blockPublicDevtools) return undefined;

    const blockContextMenu = (event) => event.preventDefault();
    const blockShortcuts = (event) => {
      const key = String(event.key || '').toLowerCase();
      const modifier = event.ctrlKey || event.metaKey;
      const devtoolsShortcut = key === 'f12' || (modifier && event.shiftKey && ['i', 'j', 'c', 'k'].includes(key)) || (modifier && key === 'u');
      if (devtoolsShortcut) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    document.addEventListener('contextmenu', blockContextMenu, true);
    document.addEventListener('keydown', blockShortcuts, true);
    return () => {
      document.removeEventListener('contextmenu', blockContextMenu, true);
      document.removeEventListener('keydown', blockShortcuts, true);
    };
  }, [settings.blockPublicDevtools]);

  return null;
};

export default PublicDevtoolsGuard;
